import { render, staticRenderFns } from "./PetugasIapiEdit.vue?vue&type=template&id=05b8c8a7&scoped=true&"
import script from "./PetugasIapiEdit.vue?vue&type=script&lang=js&"
export * from "./PetugasIapiEdit.vue?vue&type=script&lang=js&"
import style0 from "./PetugasIapiEdit.vue?vue&type=style&index=0&id=05b8c8a7&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8c8a7",
  null
  
)

export default component.exports